import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from './paths';
import { mediaPlansRoutes, ordersRoutes } from './shared';
import { PageRoute } from './types';

export const advertiserRoutes: PageRoute[] = [
  ...mediaPlansRoutes,
  ...ordersRoutes,
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/OnboardingPage')),
    path: `${ROUTES.AUTHORIZED.ONBOARDING}/:step?`,
    title: 'Advertiser onboarding',
    fullScreen: true,
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/CampaignWizard')),
    path: `${ROUTES.AUTHORIZED.CAMPAIGN_WIZARD}/:step?`,
    title: 'Campaign Wizard',
    fullScreen: true,
  },
];
